import PropTypes from 'prop-types'
import {useAuth} from '@/hooks/useAuth'
import {AuthContext} from './AuthContext'

export const AuthProvider = ({shellActive = false, children}) => {
  const auth = useAuth({shellActive})
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

AuthProvider.propTypes = {
  shellActive: PropTypes.bool,
  children: PropTypes.node,
}
